import NoData from "./NoData";

interface NoDataWithContainerProps {
  message?: string | null;
}

const NoDataWithContainer = ({ message }: NoDataWithContainerProps) => {
  return (
    <div className="global-container">
      <NoData message="No Data" />
    </div>
  );
};

export default NoDataWithContainer;
